import React from 'react';
import { 
  Box, 
  Chip, 
  Fade, 
  Tooltip, 
  Typography
} from '@mui/material';
import { Web, NewReleases } from '@mui/icons-material';

export const AnimatedVersion = ({ version, isNew = false }) => {
  return (
    <Tooltip title={isNew ? "New version available!" : `Version ${version}`}>
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <Chip
          icon={<Web />}
          label={
            <Typography variant="caption" sx={{ ml: 1, color: 'text.disabled', fontSize: '1rem', fontFamily: 'monospace' }}>
              v{version}
            </Typography>
          }
          color={isNew ? "secondary" : "default"}
          variant={isNew ? "filled" : "outlined"}
        />
        {isNew && (
          <Fade in={true}>
            <NewReleases 
              sx={{ 
                position: 'absolute',
                top: -8,
                right: -8,
                fontSize: 16,
                color: 'secondary.main'
              }} 
            />
          </Fade>
        )}
      </Box>
    </Tooltip>
  );
};